"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const axios_1 = __importDefault(require("axios"));
const store_1 = __importDefault(require("./store"));
const bootstrap_vue_1 = __importDefault(require("bootstrap-vue"));
const vue_owl_carousel_1 = __importDefault(require("vue-owl-carousel"));
vue_1.default.component('owl-carousel', vue_owl_carousel_1.default);
vue_1.default.use(bootstrap_vue_1.default, {
    BButton: { variant: 'primary' }
});
const x5_gmaps_1 = __importDefault(require("x5-gmaps"));
vue_1.default.use(x5_gmaps_1.default, process.env.MIX_GOOGLE_MAPS_KEY);
const vue_slider_component_1 = __importDefault(require("vue-slider-component"));
vue_1.default.component('VueSlider', vue_slider_component_1.default);
let meta = document.head.querySelector('meta[name="csrf-token"]');
axios_1.default.defaults.headers.common['X-CSRF-TOKEN'] = meta.content;
axios_1.default.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const components_1 = __importDefault(require("./components"));
new vue_1.default({ el: '#app', components: components_1.default, store: store_1.default });
